import React, { useState } from "react";

const TruncateText = ({ text, limit = 200, className = "" }) => {
  const [isReadMore, setIsReadMore] = useState(false);

  if (!text) return null;

  const truncatedText =
    text.length > limit && !isReadMore
      ? text.substring(0, limit) + "..."
      : text;

  return (
    <div>
      <p className={className} style={{ whiteSpace: "pre-wrap" }}>
        {truncatedText}{" "}
        {text.length > limit && (
          <span
            className="text-decoration-underline theme-color fw-semibold cursor-pointer"
            onClick={() => setIsReadMore(!isReadMore)}
          >
            {isReadMore ? "Read Less" : "Read More"}
          </span>
        )}
      </p>
    </div>
  );
};

export default TruncateText;
